export class TopicForm{
  constructor(
    public courseId: string = "",
    public title: string = "",
    public description: string = "",
    public tag: string = "",
    public id?: string,
    public mediaId?: string,
  ) {}
}
